import { Formik, Form } from "formik";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui";
import { getErrorMessage } from "@/lib/strapi";
import { ROUTES } from "@/routes/paths";
import {
  useCreateOrder,
  CheckoutFields,
  checkoutSchema,
  checkoutInitialValues,
} from "@/features/orders";

/**
 * Places an order for a catalog product.
 * There is no account, so contact and delivery details are collected here and
 * the customer is sent straight to their private tracking page.
 */
export function PlaceOrderForm({ product }) {
  const navigate = useNavigate();

  const createOrder = useCreateOrder({
    onSuccess: (order) => {
      toast.success(`Order ${order.order_number} placed — check your email.`);
      navigate(ROUTES.TRACK(order.access_token));
    },
    onError: (error) => toast.error(getErrorMessage(error, "Could not place order")),
  });

  return (
    <Formik
      initialValues={checkoutInitialValues}
      validationSchema={checkoutSchema}
      onSubmit={(values) =>
        createOrder.mutate({
          ...values,
          section: product.section,
          product_title: product.title,
        })
      }
    >
      <Form className="space-y-5">
        <CheckoutFields />
        <Button type="submit" className="w-full" isLoading={createOrder.isPending}>
          Place order
        </Button>
      </Form>
    </Formik>
  );
}

export default PlaceOrderForm;
